import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=52c6cb86&lang=less"

const __exports__ = script;

export default __exports__